<div class="row">
  <div class="col-sm-8">
    <ng-container *ngIf="flightRecord.refreshedOffer; else singleItineraries">
      <div class="row">
        <div class="col-6">
          <p class="fw-bold text-secondary small mb-2">Données de réservation</p>
          <ng-container *ngTemplateOutlet="itineraryBlock; context: { $implicit: flightRecord.offer }"></ng-container>
        </div>
        <div class="col-6">
          <p class="fw-bold text-secondary small mb-1">Données actualisées</p>
          <p *ngIf="flightRecord.lastRefreshDate" class="text-secondary small mb-2">
            Actualisé le {{ flightRecord.lastRefreshDate | date: 'dd/MM/yyyy HH:mm' }}
          </p>
          <ng-container *ngTemplateOutlet="itineraryBlock; context: { $implicit: flightRecord.refreshedOffer }"></ng-container>
        </div>
      </div>
    </ng-container>
    <ng-template #singleItineraries>
      <ng-container *ngTemplateOutlet="itineraryBlock; context: { $implicit: flightRecord.offer }"></ng-container>
    </ng-template>
    <div>
      <div class="row background m-1 p-1 corners font-weight-bold">
        Bagages demandés par le client
      </div>
      <table class="table table-striped" *ngIf="(flightRecord.requestedLuggage?.length || 0) > 0">
        <thead>
          <tr>
            <th>Quantité</th>
            <th>Poids (KG)</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let bag of flightRecord.requestedLuggage">
            <td>{{ bag.quantity || '1' }}</td>
            <td>{{ getWeight(bag.key) }} kg<ng-container *ngIf="isBrandedUpsell && brandedFareName"> — tarif {{ brandedFareName }}</ng-container></td>
            <td>
              <span [class.green-colored]="flightRecord.luggageBagStatus === BookingSubStatusEnum.OK"
                [class.red-colored]="flightRecord.luggageBagStatus === BookingSubStatusEnum.KO"
                [class.orange-colored]="flightRecord.luggageBagStatus === BookingSubStatusEnum.NO">
                {{ `${flightRecord.luggageBagStatus} ${flightRecord.luggageWarningMessage}` }}
              </span>
          </tr>
        </tbody>
      </table>
      <div *ngIf="(flightRecord.requestedLuggage?.length || 0) === 0 && !isLuggageIncludedInOffer">
        <p class="text-start">Pas de bagages demandés</p>
      </div>
      <div *ngIf="(flightRecord.requestedLuggage?.length || 0) === 0 && isLuggageIncludedInOffer">
        <p class="text-start">Bagages inclus</p>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Source</th>
          <th>Réf. Pulpo</th>
          <th>PNR Compagnie</th>
          <th>PNR Fournisseur</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {{ flightRecord.source || 'N/A'
            }}
          </td>
          <td>{{ flightRecord.flightInternalReference }}</td>
          <td>{{ flightRecord.locatorCode }}</td>
          <td>{{ flightRecord.supplierLocatorCode }}</td>
        </tr>
      </tbody>
    </table>

    <ng-container *ngIf="(flightRecord.alternativeProviderOffers?.length || 0) > 0">
      <div class="row background m-1 p-1 corners font-weight-bold">
        Autres offres comparées
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Fournisseur</th>
            <th>Source</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alternative of flightRecord.alternativeProviderOffers">
            <td>{{ alternative.provider }}</td>
            <td>{{ alternative.source }}</td>
            <td>{{ alternative.total }} {{ alternative.currency }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>

<ng-template #itineraryBlock let-offer>
  <div *ngFor="let itinerary of [offer.way, offer.back]">
    <div class="row background m-1 p-1 corners font-weight-bold">
      {{ 'Vols ' +
      itinerary.segments[0].origin +
      '-' +
      itinerary.segments[itinerary.segments.length - 1].destination }}
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Décollage</th>
          <th>Atterrissage</th>
          <th>Vol</th>
          <th>Bagages</th>
          <th>ADT</th>
          <th>CHD</th>
          <th>BEBE</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let segment of itinerary.segments">
          <td>
            {{ segment.departureTime | date : 'dd/MM/yyyy' }}
            {{ segment.origin }}
            {{ segment.departureTime | date : 'HH:mm' }}
          </td>
          <td>
            {{ segment.arrivalTime | date : 'dd/MM/yyyy' }}
            {{ segment.destination }}
            {{ segment.arrivalTime | date : 'HH:mm' }}
          </td>
          <td>
            {{ segment.airlineIata + ' ' + segment.flightNumber }}
          </td>
          <td>
            <span [class.colored]="isLuggageIncludedInOffer"
              [class.red-colored]="!isLuggageIncludedInOffer">
              {{ luggageSummary }}
            </span>
          </td>
          <td>{{ travelerRecord.adultNumber }}</td>
          <td>{{ travelerRecord.childNumber }}</td>
          <td>{{ travelerRecord.babyNumber }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>